import { GET_LOADING } from './types';

export const getters = {
  [GET_LOADING]: state => {
    return state.loading > 0;
  }
};
